// // Added By Farhan Khan Khan on 24-Dec-2025
// /* eslint-disable no-lone-blocks */
// import React, { useState, useEffect } from "react";
// import { Alert, Col, Container, Row, Modal } from "react-bootstrap";
// import Button from "react-bootstrap/Button";
// import Form from "react-bootstrap/Form";
// import { Link, useNavigate } from "react-router-dom";
// import "react-bootstrap-typeahead/css/Typeahead.css";
// import solisPowerApi from "../../api/solisPowerApi";
// import moment from "moment";
// import { useLocation } from "react-router-dom";
// import PubSub from "pubsub-js";
// import Select from "react-select";
// import Accordion from "react-bootstrap/Accordion";
// import Card from "react-bootstrap/Card";
// import CityState from "../../constants/CityState.json";
// import { LIST_TAB_TITLE } from "../../constants/CONSTANT";
// import * as constants from "../../constants/CONSTANT";
// import jwt_decode from "jwt-decode";
// import Helmet from "react-helmet";
// import Main from "../layout/Main";
// import { handleUppercaseChange } from "../common/UpperCaseMethod";

// const ProductEdit = (props) => {
//   const [validated, setValidated] = useState(false);
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [product, setProduct] = useState(location.state ? location.state : {});
//   const [brandOptions, setBrandOptions] = useState([]);
//   const [selectedBrand, setSelectedBrand] = useState(null);

//   useEffect(() => {
//     async function init() {
//       const brands = await fetchActiveBrands();
//       if (product.id && product.brand_id && brands) {
//         // Set selected brand if editing
//         const brand = brands.find(b => b.id === product.brand_id);
//         if (brand) {
//           setSelectedBrand({ value: brand.id, label: brand.name });
//         }
//       }
//     }
//     init();
//   }, []);

//   const fetchActiveBrands = async () => {
//     const brands = await solisPowerApi.fetchActiveBrands();
//     if (brands) {
//       const options = brands.map(brand => ({
//         value: brand.id,
//         label: brand.name
//       }));
//       setBrandOptions(options);
//       return brands;
//     }
//     return [];
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setProduct({ ...product, [name]: value });
//   };

//   const handleBrandChange = (selectedOption) => {
//     setSelectedBrand(selectedOption);
//     setProduct({ ...product, brand_id: selectedOption ? selectedOption.value : null });
//   };

//   // Added validation by Farhan Khan starts
//   const checkRequiredFields = () => {
//     if (
//       product.name &&
//       product.name.trim() !== "" &&
//       product.product_type &&
//       product.product_type.trim() !== "" &&
//       product.brand_id &&
//       product.description &&
//       product.description.trim() !== "" &&
//       product.status &&
//       product.status.trim() !== ""
//     ) {
//       return false;
//     }
//     return true;
//   };

//   // Added validation by Farhan Khan ends

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     // Added validation by Farhan Khan starts
//     if (checkRequiredFields()) {
//       setValidated(true);
//       return;
//     }
//     // Added validation by Farhan Khan ends
//     //========= Logic to perform Create or Edit ======
//     let result = {};
//     if (product.id) {
//       result = await solisPowerApi.saveProduct(product);
//       if (result.success) {
//         PubSub.publish("RECORD_SAVED_TOAST", {
//           title: "Record Saved",
//           message: "Record saved successfully",
//         });
//         navigate(`/products/${product.id}`, { state: product });
//       }
//     } else {
//       result = await solisPowerApi.createProduct(product);
//       if (result != null && result.success) {
//         PubSub.publish("RECORD_SAVED_TOAST", {
//           title: "Record Saved",
//           message: "Record saved successfully",
//         });
//         // Fixed Product Update & Detail Issue - Use data from response
//         // Added By Farhan Khan Khan on 24-Dec-2025
//         const productData = result.data || { id: result.id };
//         navigate(`/products/${result.id}`, { state: productData });
//       }
//     }
//   };

//   const handleCancel = () => {
//     if (product.id) {
//       navigate("/products/" + product.id, { state: product });
//     } else {
//       navigate(`/products`);
//     }
//   };

//   return (
//     <Main>
//       <>
//         <Helmet>
//           <title>{LIST_TAB_TITLE.ProductEdit}</title>
//         </Helmet>
//       </>
//       <Container className="view-form">
//         <Row>
//           <Col></Col>
//           <Col lg={8} className="pb-1 pt-2">
//             <Link className="nav-link" to="/products">
//               Home <i className="fa-solid fa-chevron-right"></i>{" "}
//               <div style={{ color: "#23468c", display: "inline" }}>
//                 Products
//               </div>
//             </Link>
//           </Col>
//           <Col></Col>
//         </Row>
//         <Row>
//           <Col></Col>
//           <Col lg={8}>
//             <Form
//               className="mt-3"
//               onSubmit={handleSubmit}
//               noValidate
//               validated={validated}
//             >
//               <Row className="view-form-header">
//                 <Col lg={8}>
//                   {product.id ? <h5>Edit Product</h5> : <h5>Create Product</h5>}
//                 </Col>
//                 <Col lg={4} className="d-flex gap-3 justify-content-end">
//                   <Button
//                     size="sm"
//                     className="btn-save"
//                     onClick={handleSubmit}
//                   >
//                     Save
//                   </Button>
//                   <Button
//                     size="sm"
//                     className="btn-cancel"
//                     onClick={handleCancel}
//                   >
//                     Cancel
//                   </Button>
//                 </Col>
//               </Row>

//               <Row className="ibs-edit-form pb-3 ">
//                 <Row lg={12}>
//                   <Col lg={6}>
//                     <Form.Group className="mx-3">
//                       <Form.Label
//                         className="form-view-label"
//                         htmlFor="formBasicName"
//                       >
//                         Product Name
//                       </Form.Label>
//                       <Form.Control
//                         required
//                         type="text"
//                         name="name"
//                         placeholder="Enter Product Name"
//                         value={product.name}
//                         onChange={(e) => handleUppercaseChange(e, handleChange)}
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         Please provide Product Name.
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                   </Col>
//                   <Col lg={6}>
//                     <Form.Group className="mx-3">
//                       <Form.Label
//                         className="form-view-label"
//                         htmlFor="formBasicProductType"
//                       >
//                         Product Type
//                       </Form.Label>
//                       <Form.Select
//                         aria-label="Select product type"
//                         name="product_type"
//                         value={product.product_type}
//                         onChange={handleChange}
//                         required
//                       >
//                         <option value="">--Select--</option>
//                         <option value="material">Material</option>
//                         <option value="non_material">Non Material</option>
//                       </Form.Select>
//                       <Form.Control.Feedback type="invalid">
//                         Please provide Product Type.
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                   </Col>
//                   <Col lg={6}>
//                     <Form.Group className="mx-3">
//                       <Form.Label
//                         className="form-view-label"
//                         htmlFor="formBasicBrand"
//                       >
//                         Brand
//                       </Form.Label>
//                       <Select
//                         placeholder="Select Brand..."
//                         onChange={handleBrandChange}
//                         options={brandOptions}
//                         value={selectedBrand}
//                         isClearable
//                         required
//                       />
//                       <Form.Control.Feedback type="invalid" style={{ display: product.brand_id ? 'none' : 'block' }}>
//                         Please provide Brand.
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                   </Col>
//                   <Col lg={6}>
//                     <Form.Group className="mx-3">
//                       <Form.Label
//                         className="form-view-label"
//                         htmlFor="formBasicStatus"
//                       >
//                         Status
//                       </Form.Label>
//                       <Form.Select
//                         aria-label="Select status"
//                         name="status"
//                         value={product.status}
//                         onChange={handleChange}
//                         required
//                       >
//                         <option value="">--Select--</option>
//                         <option value="Active">Active</option>
//                         <option value="Inactive">Inactive</option>
//                       </Form.Select>
//                       <Form.Control.Feedback type="invalid">
//                         Please provide status.
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                   </Col>
//                   <Col lg={12}>
//                     <Form.Group className="mx-3">
//                       <Form.Label
//                         className="form-view-label"
//                         htmlFor="formBasicDescription"
//                       >
//                         Description
//                       </Form.Label>
//                       <Form.Control
//                         required
//                         as="textarea"
//                         name="description"
//                         placeholder="Enter Description"
//                         value={product.description}
//                         onChange={(e) => handleUppercaseChange(e, handleChange)}
//                         rows={3}
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         Please provide Description.
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                   </Col>
//                 </Row>
//               </Row>
//             </Form>
//           </Col>
//           <Col></Col>
//         </Row>
//       </Container>
//     </Main>
//   );
// };

// export default ProductEdit;

// Added By Farhan Khan Khan on 24-Dec-2025
/* eslint-disable no-lone-blocks */
import React, { useState, useEffect } from "react";
import { Alert, Col, Container, Row, Modal, Badge } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Link, useNavigate } from "react-router-dom";
import "react-bootstrap-typeahead/css/Typeahead.css";
import solisPowerApi from "../../api/solisPowerApi";
import moment from "moment";
import { useLocation } from "react-router-dom";
import PubSub from "pubsub-js";
import Select from "react-select";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import CityState from "../../constants/CityState.json";
import { LIST_TAB_TITLE } from "../../constants/CONSTANT";
import * as constants from "../../constants/CONSTANT";
import jwt_decode from "jwt-decode";
import Helmet from "react-helmet";
import Main from "../layout/Main";
import { handleUppercaseChange } from "../common/UpperCaseMethod";
import { formatDateForView } from "../../utils/helper";

const ProductEdit = (props) => {
  const [validated, setValidated] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [product, setProduct] = useState(location.state ? location.state : {});
  const [brandOptions, setBrandOptions] = useState([]);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [specificationOptions, setSpecificationOptions] = useState([]);
  const [selectedSpecifications, setSelectedSpecifications] = useState([]);

  // Normalize ids to array for multi-select (backward compatible: single UUID → [uuid])
  const toBrandIdsArr = (v) => !v ? [] : Array.isArray(v) ? v : [v];
  const toSpecIdsArr = (v) => !v ? [] : Array.isArray(v) ? v : [v];
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const [duplicateData, setDuplicateData] = useState({});

  useEffect(() => {
    async function init() {
      const brands = await fetchActiveBrands();
      const categories = await solisPowerApi.fetchCategories();

      if (categories) {
        setCategoryOptions(categories.filter(c => c.status === 'Active').map(c => ({ value: c.id, label: c.category_name || c.name || c.code })));
      }

      if (product.id && product.brand_id && brands) {
        const ids = toBrandIdsArr(product.brand_id);
        if (ids.length > 0) {
          const opts = brands.filter(b => ids.includes(b.id)).map(b => ({ value: b.id, label: b.name }));
          setSelectedBrands(opts);
        }
      }
    }
    init();
  }, []);

  const fetchActiveBrands = async () => {
    const brands = await solisPowerApi.fetchActiveBrands();
    if (brands) {
      const options = brands.map(brand => ({
        value: brand.id,
        label: brand.name
      }));
      setBrandOptions(options);
      return brands;
    }
    return [];
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProduct({ ...product, [name]: value });
  };

  const handleBrandChange = (selected) => {
    const arr = selected && Array.isArray(selected) ? selected : [];
    setSelectedBrands(arr);
    setProduct({ ...product, brand_id: arr.map(s => s.value) });
  };

  const handleCategoryChange = (selected) => {
    setProduct({ ...product, category_id: selected ? selected.value : null });
  };

  // const handleSpecificationChange = (selected) => {
  //   const arr = selected && Array.isArray(selected) ? selected : [];
  //   setSelectedSpecifications(arr);
  //   setProduct({ ...product, specification_ids: arr.map(s => s.value) });
  // };

  // Added validation by Farhan Khan starts
  // product_unit_price required for Non-Material products
  // brand_id: array of UUIDs (multi-select), at least one required
  const checkRequiredFields = () => {
    const brandIds = toBrandIdsArr(product.brand_id);
    if (
      product.name &&
      product.name.trim() !== "" &&
      product.product_type &&
      product.product_type.trim() !== "" &&
      brandIds.length > 0 &&
      product.description &&
      product.description.trim() !== "" &&
      product.status &&
      product.status.trim() !== ""
    ) {
      if (product.product_type === "non_material") {
        const price = product.product_unit_price;
        if (price === undefined || price === null || String(price).trim() === "") return true;
        const num = parseFloat(price);
        if (isNaN(num) || num < 0) return true;
      }
      return false;
    }
    return true;
  };

  // Added validation by Farhan Khan ends

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Added validation by Farhan Khan starts
    if (checkRequiredFields()) {
      setValidated(true);
      return;
    }
    // Added validation by Farhan Khan ends
    //========= Logic to perform Create or Edit ======
    let result = {};
    try {
      if (product.id) {
        result = await solisPowerApi.saveProduct(product);
        if (result && result.success) {
          PubSub.publish("RECORD_SAVED_TOAST", {
            title: "Record Saved",
            message: "Record saved successfully",
          });
          navigate(`/products/${product.id}`, { state: product });
        }
      } else {
        result = await solisPowerApi.createProduct(product);

        console.log("first result.product_exists.data", result?.data);

        if (result != null && result.product_exists) {
          setDuplicateData(result?.data)
          setShowDuplicateModal(true);
          return;
        }
        if (result != null && result.success) {
          PubSub.publish("RECORD_SAVED_TOAST", {
            title: "Record Saved",
            message: "Record saved successfully",
          });
          const productData = result.data || { id: result.id };
          navigate(`/products/${result.id}`, { state: productData });
        }
      }
    } catch (err) {
      const msg = err?.response?.data?.errors || err?.message || "Something went wrong.";
      PubSub.publish("RECORD_SAVED_TOAST", { title: "Error", message: msg });
    }
  };

  const handleCreateAnyway = async () => {
    try {
      const result = await solisPowerApi.createProduct({ ...product, force_create: true });
      if (result != null && result.success) {
        setShowDuplicateModal(false);
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Record Saved",
          message: "Record saved successfully",
        });
        const productData = result.data || { id: result.id };
        navigate(`/products/${result.id}`, { state: productData });
      }
    } catch (err) {
      const msg = err?.response?.data?.errors || err?.message || "Something went wrong.";
      PubSub.publish("RECORD_SAVED_TOAST", { title: "Error", message: msg });
    }
  };

  const handleCancel = () => {
    if (product.id) {
      navigate("/products/" + product.id, { state: product });
    } else {
      navigate(`/products`);
    }
  };

  return (
    <Main>
      <>
        <Helmet>
          <title>{LIST_TAB_TITLE.ProductEdit}</title>
        </Helmet>
      </>
      <Container className="view-form">
        <Row>
          <Col></Col>
          <Col lg={8} className="pb-1 pt-2">
            <Link className="nav-link" to="/products">
              Home <i className="fa-solid fa-chevron-right"></i>{" "}
              <div style={{ color: "#23468c", display: "inline" }}>
                Products
              </div>
            </Link>
          </Col>
          <Col></Col>
        </Row>
        <Row>
          <Col></Col>
          <Col lg={8}>
            <Form
              className="mt-3"
              onSubmit={handleSubmit}
              noValidate
              validated={validated}
            >
              <Row className="view-form-header">
                <Col lg={8}>
                  {product.id ? <h5>Edit Product</h5> : <h5>Create Product</h5>}
                </Col>
                <Col lg={4} className="d-flex gap-3 justify-content-end">
                  <Button
                    size="sm"
                    className="btn-save"
                    onClick={handleSubmit}
                  >
                    Save
                  </Button>
                  <Button
                    size="sm"
                    className="btn-cancel"
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                </Col>
              </Row>

              <Row className="ibs-edit-form pb-3 ">
                <Row lg={12}>
                  <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicName"
                      >
                        Product Name
                      </Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="name"
                        placeholder="Enter Product Name"
                        value={product.name}
                        onChange={(e) => handleUppercaseChange(e, handleChange)}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please provide Product Name.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicProductType"
                      >
                        Product Type
                      </Form.Label>
                      <Form.Select
                        aria-label="Select product type"
                        name="product_type"
                        value={product.product_type}
                        onChange={handleChange}
                        required
                      >
                        <option value="">--Select--</option>
                        <option value="material">Material</option>
                        <option value="non_material">Non Material</option>
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        Please provide Product Type.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  {product.product_type === "non_material" &&
                    <>
                      <Col lg={6}>
                        <Form.Group className="mx-3">
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicProductUnitPrice"
                          >
                            Unit Price
                          </Form.Label>
                          <Form.Control
                            type="number"
                            step="0.01"
                            min="0"
                            name="product_unit_price"
                            placeholder="Enter Unit Price"
                            value={product.product_unit_price ?? ""}
                            onChange={handleChange}
                            required={product.product_type === "non_material"}
                          />
                          <Form.Control.Feedback type="invalid">
                            Unit Price is required for Non-Material products.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </>
                  }
                  <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicBrand"
                      >
                        Brand
                      </Form.Label>
                      <Select
                        placeholder="Select Brand(s)..."
                        onChange={handleBrandChange}
                        options={brandOptions}
                        value={selectedBrands}
                        isMulti
                        isClearable
                        required
                      />
                      <Form.Control.Feedback type="invalid" style={{ display: (toBrandIdsArr(product.brand_id).length > 0) ? 'none' : 'block' }}>
                        Please provide Brand.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">Category</Form.Label>
                      <Select
                        placeholder="Select Category..."
                        onChange={handleCategoryChange}
                        options={categoryOptions}
                        value={categoryOptions.find(o => o.value === product.category_id) || null}
                        isClearable
                      />
                    </Form.Group>
                  </Col>

                  <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicStatus"
                      >
                        Status
                      </Form.Label>
                      <Form.Select
                        aria-label="Select status"
                        name="status"
                        value={product.status}
                        onChange={handleChange}
                        required
                      >
                        <option value="">--Select--</option>
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        Please provide status.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col lg={12}>
                    <Form.Group className="mx-3">
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicDescription"
                      >
                        Description
                      </Form.Label>
                      <Form.Control
                        required
                        as="textarea"
                        name="description"
                        placeholder="Enter Description"
                        value={product.description}
                        onChange={(e) => handleUppercaseChange(e, handleChange)}
                        rows={3}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please provide Description.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
              </Row>
            </Form>
          </Col>
          <Col></Col>
        </Row>
      </Container>

      <Modal size="lg" show={showDuplicateModal} onHide={() => setShowDuplicateModal(false)} centered>
        <Modal.Header closeButton className="view-form-header">
          <Modal.Title>
            Product with this name and brand already exists.
            {/* Product Already Exists */}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <h5>
            Product with this name and brand already exists. Do you want to create it anyway?
          </h5> */}

          <Row className="py-3 ibs-edit-form">
            <Col lg={6} className="my-2">
              <h4>Product Name  :  <span style={{ fontSize: '17px' }}>{duplicateData.name}</span></h4>
            </Col>
            <Col lg={6} className="my-2">
              <h4>Product Type  :  <span style={{ fontSize: '17px' }}>
                <Badge bg="info">
                  {duplicateData?.product_type === 'material' ? 'Material' : 'Non Material'}
                </Badge>
              </span></h4>
            </Col>
            <Col lg={6} className="my-2">
              <h4>Brand  :  <span style={{ fontSize: '17px' }}>{duplicateData.brand_name}</span></h4>

            </Col>
            <Col lg={6} className="my-2">
              <h4>Status : <span style={{ fontSize: '17px' }}>
                <Badge bg={duplicateData?.status === "Active" ? "success" : "secondary"}>
                  {duplicateData.status}
                </Badge>
              </span>
              </h4>

            </Col>
            <Col lg={12} className="my-2">
              <h4>Description  : <span style={{ fontSize: '17px' }}>{duplicateData.description}</span></h4>

            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="view-form-header">
          <Button variant="secondary" onClick={() => setShowDuplicateModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" className="btn-save" onClick={handleCreateAnyway}>
            Create anyway
          </Button>
        </Modal.Footer>
      </Modal>
    </Main>
  );
};

export default ProductEdit;
